// First, define your Amazon ad code as a string
// the <script> portion of the amazon ads must be removed and placed before the </body> tag inside theme.liquid
var amazonAd1 = '<div id="amzn-assoc-ad-b1d75b6c-f4bd-40ef-8bed-d775314be16f"></div>';

var amazonAd2 = '<div id="amzn-assoc-ad-d1d036e1-906d-4bb3-8e46-5b5d17233e8c"></div>';

var amazonAd3 = '<div id="amzn-assoc-ad-4f198a58-cbe4-4519-863b-98ad1a36f071"></div>';

var amazonAd4 = '<div id="amzn-assoc-ad-e358bf00-66eb-455d-bf2f-9fb323d34237"></div>';

var googleAd1 = ''+
'<ins class="adsbygoogle" style="display:block" data-ad-client="ca-pub-6147230782579034" data-ad-slot="8845103049" data-ad-format="auto" data-full-width-responsive="true"></ins>'+
'<p>G ad test</p>';

// Next, get all the <p> elements in your content
var paragraphs = document.getElementsByTagName('p');

// Loop through the paragraphs and insert the ads as necessary
for (var i = 0; i < paragraphs.length; i++) {
  if (i == 4) { // If this is the 4th paragraph
    paragraphs[i].insertAdjacentHTML('afterend', amazonAd1); // Insert the first ad after it
  }
  if (i == 16) { // If this is the 16th paragraph
    paragraphs[i].insertAdjacentHTML('afterend', amazonAd2); // Insert the second ad after it
  }
  if (i == 22) { // If this is the 16th paragraph
    paragraphs[i].insertAdjacentHTML('afterend', amazonAd3); // Insert the second ad after it
  }
  // if (i == 33) { // If this is the 16th paragraph
  //   paragraphs[i].insertAdjacentHTML('afterend', googleAd1); // Insert the second ad after it
  // }
  if (i == 40) { // If this is the 16th paragraph
    paragraphs[i].insertAdjacentHTML('afterend', amazonAd4); // Insert the second ad after it
  }
}